import { useState } from "react";
import { Lock } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { toast } from "sonner";

const KEY = "sv_vip_ok";

export default function VipGate({ children }) {
  const { settings } = useSettings();
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem(KEY) === "1");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  if (settings === null) return null;
  const gate = settings?.vip_gate || {};
  if (!gate.enabled || unlocked) return children;

  const unlock = async () => {
    setLoading(true);
    try {
      await api.post("/vip-gate/unlock", { password: pw });
      sessionStorage.setItem(KEY, "1");
      setUnlocked(true);
    } catch (e) { toast.error(apiErr(e, "Incorrect access password.")); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-linen flex items-center justify-center px-6" data-testid="vip-gate">
      <div className="max-w-md w-full text-center">
        <div className="w-14 h-14 rounded-full border border-linen/30 flex items-center justify-center mx-auto mb-8">
          <Lock size={22} strokeWidth={1.5} />
        </div>
        <p className="font-body uppercase tracking-luxe text-[0.6rem] text-linen/50 mb-4">Early Access</p>
        <h1 className="font-heading text-4xl md:text-5xl tracking-tight mb-5">Sew Voyage</h1>
        <p className="font-body text-sm text-linen/70 leading-relaxed mb-8">
          {gate.message || "Enter the early-access password to view this drop."}
        </p>
        <div className="flex gap-2">
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && unlock()}
            placeholder="Access password"
            data-testid="vip-gate-input"
            className="flex-1 bg-transparent border border-linen/30 px-4 py-3 text-sm outline-none font-body placeholder:text-linen/40 focus:border-linen transition-colors"
          />
          <button
            onClick={unlock}
            disabled={loading}
            data-testid="vip-gate-submit"
            className="bg-linen text-ink font-body uppercase tracking-wide2 text-[0.65rem] px-6 hover:opacity-80 transition-opacity disabled:opacity-50"
          >
            {loading ? "…" : "Enter"}
          </button>
        </div>
      </div>
    </div>
  );
}
